// extracted by mini-css-extract-plugin
export default {"container":"ProductSelector_container__ng6GR"};